// removed by extract-text-webpack-plugin
module.exports = {"powered":"RLfpzcntzwGdo7TJL8ql0","logo":"_17D5OB5-A5cSdAofwQHmxq"};


//////////////////
// WEBPACK FOOTER
// ./src/client/Components/PoweredByLogo/PoweredByLogo.css
// module id = 1125
// module chunks = 58